import { SizableText, XStack } from '@my/ui'
import { Reaction } from 'app/types'

export interface PostReactionsProps {
  reactions: Reaction[]
}

export const PostReactions = ({ reactions }: PostReactionsProps) => {
  // Don't display the like reaction
  const filteredReactions = reactions.filter((r) => r.name !== 'like')
  const totalReactions = filteredReactions.reduce((acc, reaction) => acc + reaction.count, 0)

  if (totalReactions === 0) {
    return null
  }

  return (
    <XStack gap="$2.5" ai="center">
      <XStack fd="row">
        {filteredReactions.map((reaction) => (
          <SizableText pos="relative" size="$5" key={reaction.name} mr="$-2">
            {reaction.icon}
          </SizableText>
        ))}
      </XStack>
      <SizableText color="$overlay11" size="$1" fow="500">
        {totalReactions}
      </SizableText>
    </XStack>
  )
}
